import React from 'react';

const ResponseDisplay = ({ response, isLoading, error }) => {
  if (isLoading) {
    return (
      <div className="response-container">
        <div className="d-flex align-items-center">
          <div className="loading-spinner me-3"></div>
          <div>
            <h5 className="mb-1">Sending Request...</h5>
            <p className="mb-0 text-muted">
              Please wait while we process your request. This may take a few moments.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="response-container response-error">
        <div className="d-flex align-items-start">
          <i className="bi bi-exclamation-triangle-fill text-danger fs-4 me-3 mt-1"></i>
          <div className="flex-grow-1">
            <h5 className="text-danger mb-2">Request Failed</h5>
            <p className="mb-3">{error}</p>
            
            {response && response.statusCode && (
              <div className="mb-3">
                <strong>Status Code:</strong> {response.statusCode}
              </div>
            )}
            
            {response && response.responseData && (
              <div>
                <h6>Server Response:</h6>
                <div className="json-display">
                  {JSON.stringify(response.responseData, null, 2)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (response && response.success) {
    return (
      <div className="response-container response-success">
        <div className="d-flex align-items-start">
          <i className="bi bi-check-circle-fill text-success fs-4 me-3 mt-1"></i>
          <div className="flex-grow-1">
            <h5 className="text-success mb-2">Request Successful</h5>
            
            <div className="row mb-3">
              <div className="col-md-6">
                <strong>Status:</strong> {response.status} {response.statusText}
              </div>
              <div className="col-md-6">
                <strong>Response Time:</strong> {new Date().toLocaleTimeString()}
              </div>
            </div>
            
            {response.data && (
              <div>
                <h6>Response Data:</h6>
                <div className="json-display">
                  {JSON.stringify(response.data, null, 2)}
                </div>
              </div>
            )}
            
            {response.headers && (
              <div className="mt-3">
                <h6>Response Headers:</h6>
                <div className="json-display">
                  {JSON.stringify(
                    Object.fromEntries(
                      Object.entries(response.headers).filter(([key]) => 
                        !key.startsWith('access-control') && 
                        key !== 'connection' && 
                        key !== 'content-length'
                      )
                    ), 
                    null, 
                    2
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ResponseDisplay;
